import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";

import { FormattedMessage } from "react-intl";
import "./style.css";

const LoadingNotification = () => (
  <div className="loading-notification">
    <div className="loading-notification-wrapper">
      <div className="loading-notification-icon">
        <FontAwesomeIcon icon={faCircleNotch} className="fa-spin fa-pulse" />
      </div>
      <div className="loading-notification-text">
        <FormattedMessage id="notification.loading" />
      </div>
    </div>

  </div>
);

export default LoadingNotification;
